type LocationState = {
  from?: {
    pathname?: string;
    search?: string;
  };
};

// The page a signed-out customer was sent away from, with its query: a payment's return address carries its id there.
export function returnPath(state: unknown): string {
  const from = (state as LocationState | null)?.from;
  return from?.pathname ? `${from.pathname}${from.search ?? ""}` : "/home";
}
